'use strict';

angular.module('mobile-apps')

	.controller('GlossaryEntriesController', [
		'$window',
		'$scope',
		'$rootScope',
		'$filter',
		'AvailableLanguages',
		'SubscriptionMain',
		'EntryMain',
		'GlossaryMain',
		'SweetAlert',
		'Utilities',
		'$aside',
		'$timeout',
		'$stateParams',
		'$location',
		function ($window,
				  $scope,
				  $rootScope,
				  $filter,
				  AvailableLanguages,
				  SubscriptionMain,
				  EntryMain,
				  GlossaryMain,
				  SweetAlert,
				  Utilities,
				  $aside,
				  $timeout,
				  $stateParams,
				  $location
		)
		{

			$scope.mobileAppId = $stateParams.mobileAppId;

			$scope.data = {
				entries: [],
				addLanguage: {},
				availableLanguages: AvailableLanguages.get(),
				additionalButtons: {}
			};


			$scope.baseLanguage = 'en';

			$scope.initView = function() {
				// Get the base language
				EntryMain.loadMobileApp($scope.mobileAppId, false, function(err, mobileApp) {
					if (err) {
						Utilities.showMessage('There was a problem', 'The glossary could not be loaded', 'error');
						return;
					}

					$scope.baseLanguage = mobileApp.baseLanguage;
					$scope.mobileApp = mobileApp;
				});

				// Get the entries
				$scope.refreshEntries();
				$scope.checkIfUsageAllowed();
			};


			/**
			 * Check if the usage of the glossary is allowed
			 */
			$scope.checkIfUsageAllowed = function() {
				SubscriptionMain.getAppPlan($scope.mobileAppId, true, function(err, currentSubscription) {
					if (err) {
						// Something went wrong, in doubt let the user use the
						// glossary for now
						return;
					}

					if (currentSubscription && currentSubscription.glossary === true) {
						return true;
					}

					// Inform user that he does not has access and redirect him to another page
					Utilities.showMessage('No access to glossary ', 'This feature is only available in Pro tier or higher', 'error', function() {
						$location.path('!/#/projects');
					});
				});
			};


			$scope.refreshAdditionalButtons = function(entryId) {
				var entry = GlossaryMain.entries[entryId];

				if (!entry) {
					return;
				}

				// Add the additional buttons
				if ($scope.data.additionalButtons.hasOwnProperty(entryId)) {
					$scope.data.additionalButtons[entryId].length = 0;
				} else {
					$scope.data.additionalButtons[entryId] = [];
				}

				var tooltipText = $scope.getEntryInfo(entry);

				$scope.data.additionalButtons[entryId].push.apply($scope.data.additionalButtons[entryId],
					[
						{
							icon: 'fa fa-history',
							text: 'Change Log',
							callbackFunction: function(entryId) {
								var entry = GlossaryMain.entries[entryId];
								$scope.showHistory(entry);
							}
						},
						{
							icon: 'fa fa-info',
							text: 'Info',
							tooltip: tooltipText
						}
					]
				);

			};


			/**
			 * Creates a new translation for an entry
			 * @param entryId The id of the entry to create the translation of
			 * @param language The key of the languae the translation is in
			 */
			$scope.createLanguageEntry = function(entryId, language) {
				GlossaryMain.createLanguageEntry($scope.mobileAppId, entryId, language,
					function(err, entries) {
						if (err) {
							Utilities.showMessage('There was a problem', 'The translation could not be created', 'error');
							return;
						}

						$scope.refreshAdditionalButtons(entryId);
					}
				);
			};


			$scope.changeCallback = function(data, entryId, language) {
				if (language === 'description') {
					// A description got changed
					GlossaryMain.changeDescription($scope.mobileAppId, entryId, data,
						function(err, entries) {
							if (err) {
								Utilities.showMessage('There was a problem', 'The description could not be changed', 'error');
								return;
							}
							$scope.refreshAdditionalButtons(entryId);
						}
					);
				} else {
					// A translation got changed
					GlossaryMain.changeTranslation($scope.mobileAppId, entryId, language, data,
						function(err, entries) {
							if (err) {
								Utilities.showMessage('There was a problem', 'The translation could not be changed', 'error');
								return;
							}
							$scope.refreshAdditionalButtons(entryId);
						}
					);
				}
			};


			/**
			 * Returns basic entry information to be displayed as tooltip
			 * @param entry The entry to get the basic information of
			 * @returns {string}
			 */
			$scope.getEntryInfo = function(entry) {
				var returnData = 'Created by:\n' + entry.createdByUser.displayName;
				returnData += '\nLast updated:\n' + $filter('date')(new Date(entry.updatedAt), 'MMMM d, y, h:mm:ss a');
				return returnData;
			};


			/**
			 *  Loads the data from the server
	         */
			$scope.refreshEntries = function() {

				GlossaryMain.loadGlossary($scope.mobileAppId, true,
					function(err, entries) {
						if (err) {
							Utilities.showMessage('There was a problem', 'The entries could not be loaded. Please try again.', 'error');
							return;
						}

						for (var entryId in entries) {
							$scope.refreshAdditionalButtons(entryId);
						}

						$scope.data.entries.length = 0;
						$scope.data.entries.push.apply($scope.data.entries, _.values(GlossaryMain.entries));
					}
				);

			};


			/**
			 * Gets the index of the entry id
			 */
			$scope.getEntryIndex = function(entryId) {
				for (var i=0;i<$scope.data.entries.length;i++) {
					if ($scope.data.entries[i]._id === entryId) {
						return i;
					}
				}
				return -1;
			};


			/**
			 * Creates a glossary entry
			 */
			$scope.create = function() {
				var newEntry = {};
				newEntry[$scope.baseLanguage] = '';

				GlossaryMain.create($scope.mobileAppId, [newEntry],
					function(err, entries) {
						if (err) {
							Utilities.showMessage('There was a problem', 'Entry could not be created', 'error');
							return;
						}

						$scope.data.entries.push.apply($scope.data.entries, entries);

						entries.forEach(function(entry) {
							$scope.refreshAdditionalButtons(entry._id);
						});
					}
				);
			};


			/**
			 * Deletes a glossary entry
       		 */
			$scope.deleteEntry = function(entryId) {
				var title = 'Are you sure?';
				var text = 'This will delete glossary entry with all its translations which can not undone.';
				$scope._deleteConfirmationPopup(title, text, function(deleteConfirmed) {
					if (deleteConfirmed === true) {

						GlossaryMain.delete($scope.mobileAppId, [entryId],
							function(err, entryIds) {
								if (err) {
									Utilities.showMessage('There was a problem', 'Entry could not be deleted', 'error');
									return;
								}

								entryIds.forEach(function(entryId) {
									var index = $scope.getEntryIndex(entryId);
									if (index !== -1) {
										$scope.data.entries.splice(index, 1);
									}
								});

							}
						);

					}
				});
			};


			/**
			 * Deletes a translation of a glossary entry
       		 */
			$scope.deleteTranslation = function(entryId, language) {
				var title = 'Are you sure?';
				var text = 'This will delete the translation for language "' + $scope.data.availableLanguages[language] + '" which can not undone.';
				$scope._deleteConfirmationPopup(title, text, function(deleteConfirmed) {
					if (deleteConfirmed === true) {
						GlossaryMain.deleteTranslation($scope.mobileAppId, entryId, language,
							function(err, entries) {
								if (err) {
									Utilities.showMessage('There was a problem', 'Translation could not be deleted', 'error');
									return;
								}

								$scope.refreshAdditionalButtons(entryId);
							}
						);
					}
				});
			};


			/**
			 * Displays a popup to confirm deletion
			 * @param title The title to display
			 * @param text The text to display
			 * @param callback The callback function which either receives true or false
			 * @private
			 */
			$scope._deleteConfirmationPopup = function(title, text, callback) {
				$timeout(function() {
					SweetAlert.swal(
						{
							title: title,
							text: text,
							type: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#DD6B55',
							confirmButtonText: 'Yes, delete it!',
							cancelButtonText: 'No, cancel!',
							closeOnConfirm: true,
							closeOnCancel: true
						},
						function (isConfirm) {
							callback(isConfirm);
						}
					);
				}, 150);
			};


			/**
			 * Displays the glossary history
       		 */
			$scope.showHistory = function(entry) {

				var loadData = {};
				if (entry) {
					loadData.headline = 'for Glossary Entry';
					loadData.query = {
						glossaryEntry: entry._id
					};
				} else {
					loadData.headline = 'for Glossary';
					loadData.query = {
						glossaryEntry: true
					};
				}

				var asideInstance = $aside.open({
					templateUrl: 'modules/mobile-apps/views/changelog.client.view.html',
					controller: 'ChangelogController',
					placement: 'left',
					size: 'lg',
					resolve: {
						loadData: loadData
					}
				});
			};


			/**
			 * Custom sort function
			 */
			$scope.orderByBaseLanguageFunction = function(entry) {
				return entry.translations[$scope.baseLanguage];
			};

		}
	])


	/**
	 * Orders object entries by their key
	 */
	.filter('orderByKey', function () {
		return function (entries) {
			var sortedKeys = Object.keys(entries).sort();
			return sortedKeys;
		};
	});

